"use client";

import { getAssetImage } from "@/service/image/asset";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { CourseAskQuestionForm } from "./course-ask-questions-form/course-ask-questions-form";
import { XIcon } from "lucide-react";

export const CourseAskQuestionsModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <div className="flex max-w-96 flex-col gap-6 rounded-lg p-6 pt-12 shadow-lg">
          <XIcon
            className="absolute top-4 right-4 h-4 w-4 cursor-pointer"
            onClick={() => setIsOpen(false)}
          />
          <div className="flex w-full items-center justify-center rounded-lg bg-violet-200/30 py-5">
            <img
              src={getAssetImage("/course/ask-course-question-image.png")}
              alt="Notatnik"
              width={80}
              height={74}
            />
          </div>
          <CourseAskQuestionForm />
        </div>
      </DialogContent>
    </Dialog>
  );
};
